module.exports = __webpack_public_path__ + "static/media/122.91d36015.wav";